module.exports = __webpack_public_path__ + "static/media/Dr. Philip Oti - Mensah.698a40c2.jpeg";